import React, {useContext, useState} from 'react';
import { AccountContext } from '../AccountContext';


export default function ReleaseTransaction(props) {
    const {accountId, transactionService, setError} = useContext(AccountContext);
    const {transactionId, setRefresh} = props;
    const [releasing, setReleasng] = useState(false as boolean);

    const onReleaseClicked = async () => {
        try {
            setReleasng(true);
                await transactionService.releasePayment(accountId, transactionId);
                setRefresh(new Date());
            setReleasng(false);
        } catch (error) {
            setReleasng(false);
            setError({source: 'ReleasePayment', ...error});
        }
    };

    return (
        <div className="field fill">
            <div className="ui labeled input">
                <button className={`ui right floated button ${releasing ? 'loading': ''}`} onClick={onReleaseClicked}>Release</button>
            </div>
        </div>);
}